import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  searchQuery: '',
  platform: {},
  type: '',
};

const platformListPayloadSlice = createSlice({
  name: 'platformListPayload',
  initialState,
  reducers: {
    setPlatformPayLoadValue: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    platformValue: (state, action) => {
      return {...state, ...action.payload};
    },
    resetPlatformPayLoadValue: () => initialState,
  },
});

export const {
  setPlatformPayLoadValue,
  platformValue,
  resetPlatformPayLoadValue,
} = platformListPayloadSlice.actions;

export default platformListPayloadSlice.reducer;
